module.exports = __webpack_public_path__ + "img/character.b70ec68.webp";